/** @type {import('../help-index.js').HelpSidebarItem} */
export const AGR_CUL_CONFIG_ITEM = {
  id: 'agro_cultivos_config',
  screenId: 'agr-cul-config',
  label: 'Configuración',
  description: 'Catálogo de cultivos, estados, Kc, nutrición, escenarios y nutrientes.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Acá se define la «ficha técnica» de cada cultivo: nombre, estados fisiológicos, coeficientes Kc, curvas de absorción y extracción de nutrientes. Sin esto, siembras, riego y simulaciones no pueden calcular bien.',
      },
      {
        title: 'Pestaña Catálogo de cultivos',
        bullets: [
          'Lista: Nombre, Ciclo (Anual/Perenne), coeficiente p, Prof. radicular, Descripción, Artículo vinculado.',
          'Botón + → elegís alta asistida por IA o completar a mano.',
          'Asistido por IA: escribís el nombre (y opcionalmente la zona); la IA sugiere p, raíz, estados, Kc y nutrición; revisás y creás el cultivo completo.',
          'Completar a mano: solo la ficha básica; estados y nutrición se cargan después en las otras pestañas.',
          '«Desde plantilla…» abre un asistente con plantillas prearmadas (maíz, soja, etc.).',
        ],
        fields: [
          {
            label: 'Nombre',
            description: 'Nombre del cultivo.',
          },
          {
            label: 'Ciclo de vida',
            description:
              'Anual: una siembra por campaña. Perenne: plantación viva (uva, frutales…) con temporadas de cosecha por campaña.',
          },
          {
            label: 'p (u otro coeficiente mostrado)',
            description: 'Parámetro técnico del cultivo (ver la ayuda del campo en pantalla).',
          },
          {
            label: 'Profundidad radicular (cm)',
            description: 'Valor por defecto al crear siembras.',
          },
          {
            label: 'Descripción',
            description: 'Texto libre.',
          },
          {
            label: 'Artículo vinculado (stock cosecha)',
            description:
              'Artículo de stock donde entra la cosecha cuando registrás un evento de cosecha con ese cultivo.',
          },
        ],
      },
      {
        title: 'Pestaña Estados fisiológicos',
        paragraphs: [
          'Catálogo de estados (emergencia, floración, etc.). Alta con Nombre y Descripción. Después los asignás a cada cultivo en la pestaña siguiente.',
        ],
      },
      {
        title: 'Pestaña Asignación Kc y días',
        bullets: [
          'Elegí un cultivo.',
          'Agregá filas: estado, días de duración y Kc.',
          'Tocá «Guardar asignación» para persistir el ciclo del cultivo.',
        ],
      },
      {
        title: 'Pestaña Necesidades nutricionales',
        intro: 'Tiene sub-pestañas propias:',
        bullets: [
          'Curvas de absorción — necesidad de nutrientes a lo largo del ciclo; elegí cultivo y guardá.',
          'Coeficiente de extracción — cuánto nutriente se extrae por unidad de rinde; filas por nutriente y «Guardar».',
          'Escenarios — nombres de escenarios de extracción (los usa Fertilización y Simulaciones).',
          'Nutrientes — catálogo (símbolo, nombre, tipo, orden, parámetro de suelo vinculado).',
        ],
      },
    ],
  },
}
